import {map, set, sortBy} from 'lodash';

import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import {AccIdExpandedCell, accIdFilter, baseAccIdColumn, sortAccIds} from 'components/Table/Cell/AccId';
import TextFilter from 'components/Table/Filter/Text';
import SimpleTable from 'components/Table/Simple';
import KyError from 'components/errors/KyError';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import {useGet} from 'helpers/KyHooks';

export default function GuidelinesPage({}) {
  const {response, error} = useGet('site/guideline', {parseJson: true});

  const columns = [
    {
      id: 'guideline',
      Header: 'Guideline',
      accessor: 'guideline',
      ...baseAccIdColumn,
    },
    {
      id: 'chemicals',
      Header: 'Drugs',
      accessor: 'chemicals',
      Cell: AccIdExpandedCell,
      Filter: TextFilter,
      filter: accIdFilter,
      sortable: true,
      sortType: sortAccIds,
    },
    {
      id: 'genes',
      Header: 'Genes',
      accessor: 'genes',
      Cell: AccIdExpandedCell,
      Filter: TextFilter,
      filter: accIdFilter,
      sortable: true,
      sortType: sortAccIds,
    },
  ];

  let body = <Loading />;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (response) {
    const sources = sortBy(
      map(response.data, (g) => set(g, 'guideline.name', g.guideline.name.replace('CPIC Guideline for ', ''))),
      [(g) => g.guideline.name],
    );
    body = (
      <div>
        <InlinePage id="cpicGuidelinesHeader" showTitle={false} />
        <SimpleTable data={sources} columns={columns} disableExport={false} renderTotalFn={(n) => `${n} Guidelines`} />
      </div>
    );
  }

  return (
    <ReadableWidthTemplate title="CPIC Guidelines">
      {body}
    </ReadableWidthTemplate>
  );
}
